import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { usePurchases } from '@/hooks/usePurchases'
import { routes } from '@/routes'
import { BackLink } from '@/components/layout/BackLink'
import { ProductCard, ProductCardSkeleton } from '@/components/product/ProductCard'
import { EmptyBoxIllustration } from '@/components/ui/icons'

/**
 * "Já comprados" — os produtos que o usuário marcou como adquiridos na última
 * semana, que é o período que vale para o sorteio.
 */
export function ShoppingListPage() {
  const location = useLocation()
  const { isAuthenticated, isLoading: authLoading } = useAuth()
  const { lastWeek, isLoading } = usePurchases()

  if (!authLoading && !isAuthenticated) {
    return <Navigate to={routes.login} state={{ from: location.pathname }} replace />
  }

  return (
    <div className="mx-auto max-w-[1200px] px-4 py-5">
      <BackLink className="mb-4" />

      {isLoading || authLoading ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <ProductCardSkeleton key={index} variant="grid" />
          ))}
        </div>
      ) : lastWeek.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-4 py-10 sm:flex-row">
          <EmptyBoxIllustration className="h-20 w-24 shrink-0" />
          <p className="text-center text-[15px] leading-relaxed text-ink-soft sm:text-left">
            Sua lista de compras está vazia.
            <br />
            Adicione produtos e eles aparecerão aqui!
          </p>
        </div>
      ) : (
        <>
          <header className="mb-5">
            <h1 className="text-[20px] font-semibold leading-tight text-ink lg:text-[26px]">
              Lista de produtos comprados última semana
            </h1>
            <p className="mt-1 text-sm text-ink-soft">
              Veja os produtos que você adicionou como comprado na última semana.
            </p>
          </header>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {lastWeek.map((purchase) => (
              <ProductCard
                key={purchase.id}
                product={purchase.product}
                variant="compact"
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
